'use strict';

var Json = require("@glennsl/bs-json/lib/js/src/Json.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

var NullXhrResponse = /* @__PURE__ */Caml_exceptions.create("Request-PvpcontrollerWeb.NullXhrResponse");

var XhrError = /* @__PURE__ */Caml_exceptions.create("Request-PvpcontrollerWeb.XhrError");

var XhrAsyncError = /* @__PURE__ */Caml_exceptions.create("Request-PvpcontrollerWeb.XhrAsyncError");

function getWithDecoder(url, decode, cb) {
  var cb$1 = function (response) {
    if (response.TAG !== /* Ok */0) {
      return Curry._1(cb, {
                  TAG: /* Error */1,
                  _0: response._0
                });
    }
    try {
      return Curry._1(cb, Curry._1(decode, response._0));
    }
    catch (raw_e){
      var e = Caml_js_exceptions.internalToOCamlException(raw_e);
      return Curry._1(cb, {
                  TAG: /* Error */1,
                  _0: e
                });
    }
  };
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true, undefined, undefined);
  xhr.addEventListener("load", (function (_event) {
          var rawResponse = xhr.responseText;
          if (rawResponse == null) {
            return Curry._1(cb$1, {
                        TAG: /* Error */1,
                        _0: {
                          RE_EXN_ID: NullXhrResponse
                        }
                      });
          }
          try {
            var response = Json.parseOrRaise(rawResponse);
            return Curry._1(cb$1, {
                        TAG: /* Ok */0,
                        _0: response
                      });
          }
          catch (raw_err){
            var err = Caml_js_exceptions.internalToOCamlException(raw_err);
            return Curry._1(cb$1, {
                        TAG: /* Error */1,
                        _0: err
                      });
          }
        }));
  xhr.addEventListener("error", (function (error) {
          return Curry._1(cb$1, {
                      TAG: /* Error */1,
                      _0: {
                        RE_EXN_ID: XhrAsyncError,
                        _1: error
                      }
                    });
        }));
  try {
    xhr.send();
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    if (e.RE_EXN_ID === Js_exn.$$Error) {
      Curry._1(cb$1, {
            TAG: /* Error */1,
            _0: {
              RE_EXN_ID: XhrError,
              _1: e._1
            }
          });
    } else {
      Curry._1(cb$1, {
            TAG: /* Error */1,
            _0: e
          });
    }
  }
  return (function (param) {
            xhr.abort();
            
          });
}

function postWithContentType(url, body, contentType, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open("POST", url, true, undefined, undefined);
  xhr.addEventListener("load", (function (_event) {
          var rawResponse = xhr.responseText;
          if (rawResponse == null) {
            return Curry._1(cb, {
                        TAG: /* Error */1,
                        _0: {
                          RE_EXN_ID: NullXhrResponse
                        }
                      });
          }
          try {
            var response = Json.parseOrRaise(rawResponse);
            return Curry._1(cb, {
                        TAG: /* Ok */0,
                        _0: response
                      });
          }
          catch (raw_err){
            var err = Caml_js_exceptions.internalToOCamlException(raw_err);
            return Curry._1(cb, {
                        TAG: /* Error */1,
                        _0: err
                      });
          }
        }));
  xhr.addEventListener("error", (function (error) {
          return Curry._1(cb, {
                      TAG: /* Error */1,
                      _0: {
                        RE_EXN_ID: XhrAsyncError,
                        _1: error
                      }
                    });
        }));
  try {
    xhr.setRequestHeader("Content-type", contentType);
    xhr.send(body);
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    Curry._1(cb, {
          TAG: /* Error */1,
          _0: e
        });
  }
  return (function (param) {
            xhr.abort();
            
          });
}

function postWithContentTypeAndDecoder(url, body, contentType, decode, cb) {
  return postWithContentType(url, body, contentType, (function (response) {
                if (response.TAG !== /* Ok */0) {
                  return Curry._1(cb, {
                              TAG: /* Error */1,
                              _0: response._0
                            });
                }
                try {
                  return Curry._1(cb, Curry._1(decode, response._0));
                }
                catch (raw_e){
                  var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                  return Curry._1(cb, {
                              TAG: /* Error */1,
                              _0: e
                            });
                }
              }));
}

function post(url, body, cb) {
  return postWithContentType(url, body, "application/x-www-form-urlencoded", cb);
}

function postWithDecoder(url, body, decode, cb) {
  return post(url, body, (function (response) {
                if (response.TAG !== /* Ok */0) {
                  return Curry._1(cb, {
                              TAG: /* Error */1,
                              _0: response._0
                            });
                }
                try {
                  return Curry._1(cb, Curry._1(decode, response._0));
                }
                catch (raw_e){
                  var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                  return Curry._1(cb, {
                              TAG: /* Error */1,
                              _0: e
                            });
                }
              }));
}

exports.getWithDecoder = getWithDecoder;
exports.postWithContentTypeAndDecoder = postWithContentTypeAndDecoder;
exports.post = post;
exports.postWithDecoder = postWithDecoder;
/* No side effect */
